/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export { UserProfileApiService } from './services/user-profile-api.service';
export { UserPaymentsApiService } from './services/user-payments-api.service';
export { UserBookingsApiService } from './services/user-bookings-api.service';
export { UserBookingSharesApiService } from './services/user-booking-shares-api.service';
export { PartnerApiService } from './services/partner-api.service';
export { AdminVouchersApiService } from './services/admin-vouchers-api.service';
export { AdminUsersApiService } from './services/admin-users-api.service';
export { AdminTowerWishesApiService } from './services/admin-tower-wishes-api.service';
export { AdminTowersApiService } from './services/admin-towers-api.service';
export { AdminTowerGroupsApiService } from './services/admin-tower-groups-api.service';
export { AdminSubscriptionsApiService } from './services/admin-subscriptions-api.service';
export { AdminPinpadsApiService } from './services/admin-pinpads-api.service';
export { AdminOrganizationsApiService } from './services/admin-organizations-api.service';
export { AdminNewsApiService } from './services/admin-news-api.service';
export { AdminImagesApiService } from './services/admin-images-api.service';
export { AdminHelpApiService } from './services/admin-help-api.service';
export { AdminBookingsApiService } from './services/admin-bookings-api.service';
export { AuthenticationApiService } from './services/authentication-api.service';
export { UserVouchersApiService } from './services/user-vouchers-api.service';
export { UserTowerGroupsApiService } from './services/user-tower-groups-api.service';
export { UserStripePaymentsApiService } from './services/user-stripe-payments-api.service';
export { UserPayrexxPaymentsApiService } from './services/user-payrexx-payments-api.service';
export { UserPaypalPaymentsApiService } from './services/user-paypal-payments-api.service';
export { UserFreeHoursPaymentsApiService } from './services/user-free-hours-payments-api.service';
export { UserNewsApiService } from './services/user-news-api.service';
export { UserInvitesApiService } from './services/user-invites-api.service';
export { UserStripeCardsApiService } from './services/user-stripe-cards-api.service';
export { TowerWishesApiService } from './services/tower-wishes-api.service';
export { PayrexxPublicPaymentsApiService } from './services/payrexx-public-payments-api.service';
export { NewsPublicApiService } from './services/news-public-api.service';
export { AdminPaymentsApiService } from './services/admin-payments-api.service';
export { AdminNotificationsApiService } from './services/admin-notifications-api.service';
export { AdminInfoApiService } from './services/admin-info-api.service';
export { UserSubscriptionsApiService } from './services/user-subscriptions-api.service';
export { UserHelpApiService } from './services/user-help-api.service';
export { SwisspassApiService } from './services/swisspass-api.service';
export { VersionApiService } from './services/version-api.service';
export { ImagesApiService } from './services/images-api.service';
export { FaqApiService } from './services/faq-api.service';
export { AdminPartnerPaymentsApiService } from './services/admin-partner-payments-api.service';
export { AdminLogApiService } from './services/admin-log-api.service';
export { AdminInvoicesApiService } from './services/admin-invoices-api.service';
